const ENCODE_KEY = "38f14452bc1c58e2aa82aecaddf1b5a7d429059e0022c12b47ccb6e169a4483e";

export function encode(str) {
    let result = "";
    for (let i = 0; i < str.length; i++) {
        result += String.fromCharCode(
            str.charCodeAt(i) ^ ENCODE_KEY.charCodeAt(i % ENCODE_KEY.length)
        );
    }
    return btoa(result).replace(/=/g, "");
}

export function decode(encoded) {
    try {
        const padded = encoded + "===".slice((encoded.length + 3) % 4);
        const str = atob(padded);
        let result = "";
        for (let i = 0; i < str.length; i++) {
            result += String.fromCharCode(
                str.charCodeAt(i) ^ ENCODE_KEY.charCodeAt(i % ENCODE_KEY.length)
            );
        }
        return result;
    } catch (e) {
        return encoded;
    }
}
